"use client"
import { Input } from "@/components/atoms"
import { cn } from "@/lib/utils"
import { FieldError } from "react-hook-form"

type LabeledInputProps = {
  label: string
  error?: FieldError
} & React.InputHTMLAttributes<HTMLInputElement>

export const LabeledInput = ({
  children,
  error,
  label,
  className,
  ...props
}: LabeledInputProps) => (
  <label className={cn("label-sm block", className)}>
    <p className={cn(error && "text-negative")}>{label}</p>
    <div className="flex w-full gap-4">
      <div className="flex-1">
        <Input className={cn(error && "border-negative")} {...props} />
      </div>
      <>{children ? <div className="mt-2">{children}</div> : null}</>
    </div>
    {error && <p className="label-sm text-negative">{error.message}</p>}
  </label>
)
